import { render } from "./InicioComponent.vue?vue&type=template&id=608a327d&scoped=true"
import script from "./InicioComponent.vue?vue&type=script&lang=js"
export * from "./InicioComponent.vue?vue&type=script&lang=js"

import "./InicioComponent.vue?vue&type=style&index=0&id=608a327d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608a327d"]])

export default __exports__